import { z } from 'zod'

const nameDaysOfWeekSchema = z.union([
  z.literal('mon'),
  z.literal('tue'),
  z.literal('wed'),
  z.literal('thu'),
  z.literal('fri'),
  z.literal('sat'),
  z.literal('sun'),
])

const timePeriodSchema = z.object({
  hourOpen: z.string(),
  hourClose: z.string(),
})

export type TimePeriod = z.infer<typeof timePeriodSchema>

export const dayOfWeekSchemaGeneral = z.object({
  day: nameDaysOfWeekSchema,
  timePeriods: z.array(
    z.object({
      start: z.string(),
      end: z.string(),
    })
  ),
})

export const dayOfWeekSchemaTimeSlots = z.object({
  day: nameDaysOfWeekSchema,
  timePeriods: z.array(timePeriodSchema),
})
